var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        size: "xl",
        title: "Visualizar correo",
        "hide-footer": "",
        scrollable: ""
      },
      on: { hidden: _vm.handleClose },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _vm.selectedEmail
        ? [
            _c("div", { staticClass: "email-viewer" }, [
              _c(
                "div",
                { staticClass: "email-header border-bottom pb-3 mb-3" },
                [
                  _c("h5", { staticClass: "mb-2" }, [
                    _vm._v(_vm._s(_vm.selectedEmail.subject))
                  ]),
                  _c("div", { staticClass: "d-flex flex-wrap" }, [
                    _c("div", { staticClass: "mr-4 mb-1" }, [
                      _c("strong", [_vm._v("De:")]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.fromDisplay))
                      ])
                    ]),
                    _c("div", { staticClass: "mr-4 mb-1" }, [
                      _c("strong", [_vm._v("Para:")]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.toDisplay))
                      ])
                    ]),
                    _vm.ccDisplay
                      ? _c("div", { staticClass: "mr-4 mb-1" }, [
                          _c("strong", [_vm._v("CC:")]),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v(_vm._s(_vm.ccDisplay))
                          ])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "mb-1" }, [
                      _c("strong", [_vm._v("Fecha:")]),
                      _c("span", { staticClass: "ml-1" }, [
                        _vm._v(_vm._s(_vm.formattedDate))
                      ])
                    ])
                  ])
                ]
              ),
              _vm.hasAttachments
                ? _c(
                    "div",
                    {
                      staticClass: "email-attachments border-bottom pb-3 mb-3"
                    },
                    [
                      _c(
                        "strong",
                        [
                          _c("feather-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "PaperclipIcon", size: "14" }
                          }),
                          _vm._v(
                            " Adjuntos (" +
                              _vm._s(_vm.selectedEmail.attachments.length) +
                              "): "
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-2 d-flex flex-wrap" },
                        _vm._l(_vm.selectedEmail.attachments, function(
                          attachment
                        ) {
                          return _c(
                            "div",
                            {
                              key: attachment.id,
                              staticClass:
                                "attachment-item mr-2 mb-2 p-2 border rounded d-flex align-items-center",
                              on: {
                                click: function($event) {
                                  return _vm.downloadAttachment(attachment)
                                }
                              }
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-2 text-primary",
                                attrs: { icon: "DownloadIcon", size: "16" }
                              }),
                              _c("div", [
                                _c(
                                  "div",
                                  { staticClass: "small font-weight-bold" },
                                  [_vm._v(_vm._s(attachment.name))]
                                ),
                                _c("div", { staticClass: "small text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatSize(attachment.contentLength)
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "email-body" }, [
                _vm.loadingContent
                  ? _c(
                      "div",
                      { staticClass: "text-center py-4" },
                      [
                        _c("b-spinner", { attrs: { variant: "primary" } }),
                        _c("p", { staticClass: "mt-2 text-muted" }, [
                          _vm._v("Cargando contenido...")
                        ])
                      ],
                      1
                    )
                  : _vm.emailHtmlContent
                  ? _c("div", {
                      ref: "shadowHost",
                      staticClass: "email-html-content"
                    })
                  : _vm.emailTextContent
                  ? _c("div", { staticClass: "email-text-content" }, [
                      _c(
                        "pre",
                        {
                          staticClass: "mb-0",
                          staticStyle: {
                            "white-space": "pre-wrap",
                            "font-family": "inherit"
                          }
                        },
                        [_vm._v(_vm._s(_vm.emailTextContent))]
                      )
                    ])
                  : _c(
                      "div",
                      { staticClass: "text-center py-4 text-muted" },
                      [
                        _c("feather-icon", {
                          staticClass: "mb-2",
                          attrs: { icon: "AlertCircleIcon", size: "24" }
                        }),
                        _c("p", [
                          _vm._v("No se pudo cargar el contenido del correo")
                        ])
                      ],
                      1
                    )
              ]),
              _c(
                "div",
                { staticClass: "email-metadata border-top pt-3 mt-3" },
                [
                  _c("small", { staticClass: "text-muted" }, [
                    _c("strong", [_vm._v("Object Key:")]),
                    _vm._v(" " + _vm._s(_vm.selectedEmail.objectKey) + " ")
                  ])
                ]
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }